import IPage from "../../../interfaces/page";
import MainLayout from "../../layouts/Main/Main.layout";
import OrdersComponent from '../../Components/Orders/Orders.component'

const OrdersPage: React.FC<IPage> = () => {
    return <MainLayout component={OrdersComponent} />
}

export default OrdersPage;